<template>
  <div>
    <form @submit="on_form_submit" ref="contact_form" :class="form_class">
      <div class="block text-gray-700 text-sm">
        Please complete the short form below so we may connect you to the best
        Audenetes professional as quickly as possible
      </div>

      <div class="block text-gray-700 text-sm py-4 italic">
        If you prefer telephone contact over e-mail please let us know in the
        body of this form.
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="mb-0">
          <label class="block text-gray-700 text-sm font-bold mb-1" for="name">
            First Name*
          </label>
          <input
            :class="name_field_class"
            id="name"
            type="text"
            ref="name_field"
            value=""
          />
        </div>
        <div class="mb-0">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="lastname"
          >
            Last Name/Surname*
          </label>
          <input
            :class="lastname_field_class"
            id="lastname"
            type="text"
            ref="lastname_field"
            value=""
          />
        </div>

        <div class="mb-0">
          <label class="block text-gray-700 text-sm font-bold mb-1" for="email">
            Email*
          </label>
          <input
            :class="email_field_class"
            id="email"
            ref="email_field"
            type="email"
          />
        </div>

        <div class="mb-0">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="country"
          >
            Country*
          </label>
          <input
            :class="country_field_class"
            id="country"
            ref="country_field"
            type="text"
          />
        </div>

        <div class="mb-0">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="specialty"
          >
            Specialty
          </label>
          <select
            id="specialty"
            ref="specialty_field"
            :class="specialty_field_class"
          >
            <option value="Neonatology">Neonatology</option>
            <option value="Pediatric neurology">Pediatric neurology</option>
            <option value="Pulmonology">Pulmonology</option>
            <option value="Genetics">Genetics</option>
            <option value="Genetic Counseling">Genetic Counseling</option>
            <option value="Gastroenterology">Gastroenterology</option>
            <option value="Ophthalmology">Ophthalmology</option>
            <option value="Orthopedics">Orthopedics</option>
            <option value="Physical therapy">Physical therapy</option>
            <option value="Speech therapy">Speech therapy</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div class="mb-0">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="organization"
          >
            Institution
          </label>
          <input
            :class="organization_field_class"
            id="organization"
            ref="organization_field"
            type="text"
            placeholder=""
            value=""
          />
        </div>

        <div class="mb-0 col-span-2">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="comments"
          >
            Comments/Questions
          </label>
          <textarea
            :class="comments_field_class"
            id="comments"
            ref="comments_field"
          ></textarea>
        </div>

        <div class="pb-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="interest_xlmtm"
          >
            Do you have interest in XLMTM?
          </label>
          <select
            id="interest_xlmtm"
            ref="interest_xlmtm_field"
            :class="interest_xlmtm_field_class"
            @change="on_interest_changed($event)"
          >
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </select>
        </div>
      </div>
      <div :class="interest_fields_class">
        <div class="mb-0">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="patient_count"
          >
            How many patients do you treat?
          </label>
          <input
            :class="patient_count_field_class"
            id="patient_count"
            ref="patient_count_field"
            type="text"
            placeholder=""
            value=""
          />
        </div>

        <div class="mb-0">
          <label class="block text-gray-700 text-sm font-bold mb-1" for="age">
            Patient Age(s)
          </label>
          <input
            :class="age_field_class"
            id="age"
            ref="age_field"
            type="text"
            placeholder=""
            value=""
          />
        </div>

        <div class="mb-0">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="ventilation"
          >
            Mechanical ventilation?
          </label>
          <select
            id="ventilation"
            ref="ventilation_field"
            :class="ventilation_field_class"
            @change="on_ventilation_changed($event)"
          >
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </select>
        </div>

        <div :class="ventilation_fields_class">
          <label
            class="block text-gray-700 text-sm font-bold mb-1"
            for="invasive"
          >
            Invasive/Not Invasive?
          </label>
          <select
            id="invasive"
            ref="invasive_field"
            :class="invasive_field_class"
          >
            <option value="Invasive">Invasive</option>
            <option value="Not Invasive">Not Invasive</option>
          </select>
        </div>
      </div>
      <div class="text-xs pt-4 text-justify">
        By providing your personal information above and submitting an inquiry,
        you agree and acknowledge that Audentes will process the personal
        information you provide to send a follow up e-mail to you, in accordance
        with the Audentes
        <a
          href="https://www.audentestx.com/privacy-statement-2/"
          target="_blank"
          class="text-red-500 hover:text-red-700"
          >Data Privacy Statement</a
        >.
      </div>

      <div class="flex items-center justify-center mt-4">
        <button
          class="bg-red-700 hover:bg-red-600 text-white font-bold py-2 px-12 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >
          Submit
        </button>
      </div>
    </form>
    <div
      class="max-h-screen py-24 text-center border-red-100 border-2"
      v-if="form_status == 1"
    >
      <img src="../../assets/loading.svg" class="mx-auto" />
    </div>
    <div class="success py-40 text-center" v-if="form_status == 2">
      <strong>Thank you!</strong><br /><br />
      You info has been routed to one our specialists who will be getting back
      to you shortly
    </div>
    <div class="error py-40 text-center" v-if="form_status == 3">
      <strong class="text-red-500">Sorry, there was an error!</strong
      ><br /><br />
      The form could not be submitted. Please try again.
    </div>
  </div>
</template>
<script>
export default {
  name: "ContactForm",
  data() {
    return {
      common_field_class:
        "shadow appearance-none border rounded w-full py-1 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
      extra_name_field_class: "",
      extra_lastname_field_class: "",
      extra_email_field_class: "",
      extra_country_field_class: "",
      extra_specialty_field_class: "",
      extra_organization_field_class: "",
      extra_comments_field_class: "",
      extra_interest_xlmtm_field_class: "",
      extra_patient_count_field_class: "",
      extra_age_field_class: "",
      extra_ventilation_field_class: "",
      extra_invasive_field_class: "",

      show_interest_fields: false,
      show_ventilation_fields: false,

      form_class: "",
      timer: null
    };
  },
  computed: {
    name_field_class() {
      var str = this.common_field_class;
      str += this.extra_name_field_class;
      return str;
    },
    lastname_field_class() {
      var str = this.common_field_class;
      str += this.extra_lastname_field_class;
      return str;
    },
    email_field_class() {
      var str = this.common_field_class;
      str += this.extra_email_field_class;
      return str;
    },
    country_field_class() {
      var str = this.common_field_class;
      str += this.extra_country_field_class;
      return str;
    },
    specialty_field_class() {
      var str = this.common_field_class;
      str += this.extra_specialty_field_class;
      return str;
    },
    organization_field_class() {
      var str = this.common_field_class;
      str += this.extra_organization_field_class;
      return str;
    },
    comments_field_class() {
      var str = this.common_field_class + " h-20 ";
      str += this.extra_organization_field_class;
      return str;
    },
    interest_xlmtm_field_class() {
      var str = this.common_field_class;
      str += this.extra_comments_field_class;
      return str;
    },
    patient_count_field_class() {
      var str = this.common_field_class;
      str += this.extra_comments_field_class;
      return str;
    },
    age_field_class() {
      var str = this.common_field_class;
      str += this.extra_comments_field_class;
      return str;
    },
    ventilation_field_class() {
      var str = this.common_field_class;
      str += this.extra_comments_field_class;
      return str;
    },
    invasive_field_class() {
      var str = this.common_field_class;
      str += this.extra_invasive_field_class;
      return str;
    },
    interest_fields_class() {
      var str = "grid grid-cols-2 gap-4 hidden-fields";
      if (this.show_interest_fields) {
        str += " active";
      }
      return str;
    },
    ventilation_fields_class() {
      var str = "mb-0 hidden-fields";
      if (this.show_ventilation_fields) {
        str += " active";
      }
      return str;
    },
    form_status() {
      return this.$store.state.contact_form_status;
    }
  },

  methods: {
    on_form_submit(e) {
      e.preventDefault();

      var valid = true;

      if (this.$refs.name_field.value.length <= 0) {
        valid = false;
        this.extra_name_field_class = " border-red-500 ";
      } else {
        this.extra_name_field_class = "";
      }

      if (this.$refs.lastname_field.value.length <= 0) {
        valid = false;
        this.extra_lastname_field_class = " border-red-500 ";
      } else {
        this.extra_lastname_field_class = "";
      }

      if (this.$refs.email_field.value == "") {
        valid = false;
        this.extra_email_field_class = " border-red-500 ";
      } else {
        this.extra_email_field_class = "";
      }

      if (this.$refs.country_field.value == "") {
        valid = false;
        this.extra_country_field_class = " border-red-500 ";
      } else {
        this.extra_country_field_class = "";
      }

      if (this.$refs.specialty_field.value == "") {
        valid = false;
        this.extra_specialty_field_class = " border-red-500 ";
      } else {
        this.extra_specialty_field_class = "";
      }
      if (!valid) {
        return;
      }

      var data_to_submit = {};
      var fields_to_get = [
        { id: "name" },
        { id: "lastname" },
        { id: "email" },
        { id: "country" },
        { id: "specialty" },
        { id: "organization" },
        { id: "comments" },
        { id: "interest_xlmtm" },
        { id: "patient_count" },
        { id: "age" },
        { id: "ventilation" },
        { id: "invasive" }
      ];
      for (var i = 0; i < fields_to_get.length; i++) {
        console.log(i, fields_to_get[i].id);
        data_to_submit[fields_to_get[i].id] = this.$refs[
          fields_to_get[i].id + "_field"
        ].value;
      }
      this.$store.dispatch("submit_contact_form", data_to_submit);
      this.form_class = "hidden";
    },
    on_interest_changed(e) {
      if (this.$refs.interest_xlmtm_field.value.toLowerCase() == "yes") {
        this.show_interest_fields = true;
      } else {
        this.show_interest_fields = false;
      }
    },
    on_ventilation_changed(e) {
      if (this.$refs.ventilation_field.value.toLowerCase() == "yes") {
        this.show_ventilation_fields = true;
      } else {
        this.show_ventilation_fields = false;
      }
    },
    reset_form() {
      this.$refs.contact_form.reset();
      this.$store.dispatch("set_simple_val", {
        name: "contact_form_status",
        val: 0
      });
      this.form_class = "";
      this.show_interest_fields = false;
      this.show_ventilation_fields = false;
    }
  },
  mounted() {
    this.$refs.name_field.value = this.$store.state.booth_form.name;
    this.$refs.lastname_field.value = this.$store.state.booth_form.lastname;
    this.$refs.email_field.value = this.$store.state.booth_form.email;
    this.$refs.country_field.value = this.$store.state.booth_form.country;
    this.$refs.specialty_field.value = this.$store.state.booth_form.specialty;
  },
  watch: {
    form_status(val) {
      switch (val) {
        case 2:
        case 3:
          this.timer = setTimeout(this.reset_form.bind(this), 4000);
          break;
      }
    }
  }
};
</script>
<style scoped>
.hidden-fields {
  height: 0;
  opacity: 0;
  transition: all 0.1s;
  overflow: hidden;
}
.hidden-fields.active {
  opacity: 1;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/deprecated/ContactFormPage.vue